module.exports = __webpack_public_path__ + "static/media/rastawiki.4da4ced7.png";